import React from "react";
import { NavLink } from "react-router-dom";
import AuthService from "../AuthContext/AuthService";
import "./Sidebar.css";

const UserSidebar = ({ isVisible, closeSidebar }) => {
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  };

  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const isSuperUser = userData?.roles?.some(
    (role) => role.name === "ROLE_SUPERUSER"
  );
  return (
    <div
      className={`custom-sidebar ${isVisible ? "" : "custom-sidebar-hidden"}`}
    >
      <ul className="sidebar-menu">
        {isSuperUser && (
          <li>
            <NavLink
              to="/User-Generate-Form"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
              }
              onClick={handleLinkClick}
            >
              <i className="pi pi-objects-column"></i>
              <span>Generate Form</span>
            </NavLink>
          </li>
        )}
        <li>
          <NavLink
            to="/User-Assigned-Forms-List"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-paperclip"></i>
            <span>Assigned Forms</span>
          </NavLink>
        </li>
        {isSuperUser && (
          <li>
            <NavLink
              to="/User-Created-Forms-List"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
              }
              onClick={handleLinkClick}
            >
              <i className="pi pi-paperclip"></i>
              <span>My Forms</span>
            </NavLink>
          </li>
        )}
        {isSuperUser && (
          <li>
            <NavLink
              to="/User-Formsets-List"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
              }
              onClick={handleLinkClick}
            >
              <i className="pi pi-thumbtack"></i>
              <span>My Formsets</span>
            </NavLink>
          </li>
        )}
        {isSuperUser && (
          <li>
            <NavLink
              to="/User-Filters-List"
              className={({ isActive }) =>
                isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
              }
              onClick={handleLinkClick}
            >
              <i className="pi pi-filter"></i>
              <span>My Filters</span>
            </NavLink>
          </li>
        )}
        <li>
          <NavLink
            to="/User-Excel"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-file-excel"></i>
            <span>Excel</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/Profile"
            className={({ isActive }) =>
              isActive ? "sidebar-item active-sidebar-item" : "sidebar-item"
            }
            onClick={handleLinkClick}
          >
            <i className="pi pi-user"></i>
            <span>Profile</span>
          </NavLink>
        </li>
        <li className="sidebar-logout">
          <a
            href="/login"
            className="sidebar-item logout-button"
            onClick={AuthService.logout}
          >
            <i className="pi pi-sign-out"></i>
            <span>Logout</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default UserSidebar;
